import { CONFIG_BTN_FULLSCREEN } from "../constants/game"
import { assetsImageLoader } from "../utils/funtions"



export default class BtnFullScreen {
  /** @type Phaser.GameObjects.Container */
  mainContainer
  /**
   * @type {{
   *  context: Phaser.Scene
   *  handleOnClick: Function
   * }}
   */
  config = {}

  /**
   *
   * @param {Phaser.Scene} context
   * @param {Function} handleOnClick
   */
  constructor(context) {
    this.config.context = context
    this.state = {
      isfullscreen: false
    };
  }

  preload() {
    const assetsToLoad = {
      'open': CONFIG_BTN_FULLSCREEN.to_open,
      'close': CONFIG_BTN_FULLSCREEN.to_exit
    }

    assetsImageLoader(
      assetsToLoad,
      'fullscreen-',
      this.config.context
    )
  }

  create() {

    this.ID_CAM_FILTER = this.config.context.cameras.getCamera('minimap').id;

    this.imgIdle = this.config.context.add
      .image(
        0,
        0,
        `fullscreen-open`
      )
      .setOrigin(0.5).setScrollFactor(0).setDepth(1);

    this.imgActive = this.config.context.add
      .image(
        0,
        0,
        `fullscreen-close`
      )
      .setOrigin(0.5).setScrollFactor(0).setDepth(1).setVisible(false);


    var interactiveZone = this.config.context.add.zone(0, 0,
      this.imgIdle.width, this.imgIdle.height)
      .setRectangleDropZone(this.imgIdle.width, this.imgIdle.height)
      .setOrigin(.5)
      .setScrollFactor(0)
      .setDepth(3).setInteractive()
      .on('pointerover', () => {
        this.config.context.cursor.set("pointer")
      })
      .on('pointerout', () => {
        this.config.context.cursor.default();
      })
      .on('pointerdown', () => {
        this.style_isPressed();
        const handlerPointerUpGlobal = () => {
          this.style_isReleased();
          this.config.context.input.off('pointerup', handlerPointerUpGlobal);
        }
        this.config.context.input.on('pointerup', handlerPointerUpGlobal)
      }).on('pointerup', () => {
        this.handlePressButton();
      })

    this.mainContainer = this.config.context.add.container(
      this.getGameWSize() - CONFIG_BTN_FULLSCREEN.marginRight[this.config.context.data.get('mediaType')],
      CONFIG_BTN_FULLSCREEN.marginTop[this.config.context.data.get('mediaType')],
      [this.imgIdle, this.imgActive, interactiveZone]).setDepth(100).setScrollFactor(0);
    this.mainContainer.cameraFilter = this.ID_CAM_FILTER;


    this.updateButtons();
    this.refreshScreen();

  }
  getGameWSize() {
    return this.config.context.game.scale.width
  }


  toggleFullScreen() {
    this.state.isfullscreen = !this.state.isfullscreen;
    this.updateButtons(); 
    this.refreshScreen();
  }
  escFullScreen() {
    this.state.isfullscreen = false; 
    this.updateButtons(); 
    this.refreshScreen();
  }
  refreshScreen() {

    const game = this.config.context.game;
    const isMobile = this.config.context.data.get('mediaType') === 'mobile';
    const classname = "--fullscreen";
    const pagefullscreened = (document.fullscreenElement !== null);
    if (this.state.isfullscreen) {
      game.canvas.parentElement.classList.add(classname);
      // 

      if (isMobile) {
        game.scale.resize(window.innerWidth, window.innerHeight);
      }
      const sw = window.innerWidth / game.scale.gameSize.width;
      const sh = window.innerHeight / game.scale.gameSize.height;
      const scale = Math.min(sw, sh);

      game.canvas.style.transform = `scale(${scale})`;
      if (!pagefullscreened) {
        game.canvas.parentElement.requestFullscreen();
      }

    }
    else {
      game.canvas.parentElement.classList.remove(classname);
      game.canvas.style.transform = `scale(1)`;


      if (isMobile) {
        game.scale.resize(this.config.context.game.config.width, this.config.context.game.config.height);
      }
      if (pagefullscreened) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) { /* Safari */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE11 */
          document.msExitFullscreen();
        }
      }

    }


  }

  updateButtons() {
    this.imgIdle.setVisible(this.state.isfullscreen);
    this.imgActive.setVisible(!this.state.isfullscreen);
  }
  style_isPressed() {
    this.mainContainer.setScale(1.2);
  }
  style_isReleased() {
    this.mainContainer.setScale(1);
  }

  handlePressButton() {

    this.toggleFullScreen();
  }


}
